import { render } from "./AppRoot.vue?vue&type=template&id=2e7d6503"
import script from "./AppRoot.vue?vue&type=script&lang=js"
export * from "./AppRoot.vue?vue&type=script&lang=js"

import "./AppRoot.vue?vue&type=style&index=0&id=2e7d6503&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__